import AuthenticationService from '@/services/AuthenticationService';

export default {
  computed: {
    userHasAddReportFilesPermission() {
      return AuthenticationService.localUserProfile.Permissions.includes('AddReportFiles');
    },

    userCanUseHiddenCustomProperties() {
      return AuthenticationService.isMSMUser;
    }
  }
};
